import React, { useRef } from 'react';
import { Button } from '~/components/Button';
import { Intent } from '~/lib/intent';
import { useCopyToClipboard } from '~/lib/useCopyToClipboard';
import style from './index.module.scss';

interface CopyableTextProps {
  children: React.ReactNode;
  className?: string;
}

export const CopyableText: React.FC<CopyableTextProps> = ({ children, className }) => {
  const [copied, copy] = useCopyToClipboard(500);
  const textRef = useRef<HTMLSpanElement>(null);

  const handleCopy = () => {
    const text = textRef.current?.innerText ?? '';
    if (text) copy(text);
  };

  return (
    <div className={`${style.copyableText} ${className || ''}`}>
      <span ref={textRef} className={style.text}>
        {children}
      </span>
      <Button
        small
        className={style.copyButton}
        intent={copied ? Intent.SUCCESS : Intent.PRIMARY}
        onClick={handleCopy}
        leftIcon={<i className={`fa fa-${copied ? 'check' : 'clipboard'}`} />}
      />
    </div>
  );
};
